import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import Cookies from 'js-cookie';

var _isCordovaApp = !!window.cordova;

function getCookieByName(_ref) {
  var url = _ref.url,
      name = _ref.name;
  return new Promise(function (resolve) {
    if (_isCordovaApp) {
      window.cookieMaster.getCookieValue(url, name, function (data) {
        console.log("Cookie \"".concat(name, "\" got in \"getCookieByName\""));
        resolve(data.cookieValue);
      });
    } else {
      console.log("Cookie \"".concat(name, "\" got in \"getCookieByName\""));
      resolve(Cookies.get(name));
    }
  });
}

function purgeCookieByName(_ref2) {
  var url = _ref2.url,
      name = _ref2.name;
  return new Promise(function (resolve) {
    if (_isCordovaApp) {
      window.cookieMaster.setCookieValue(url, name, '', function () {
        console.log("Cookie \"".concat(name, "\" set in \"purgeCookieByName\""));
        resolve();
      });
    } else {
      Cookies.set(name, '');
      console.log("Cookie \"".concat(name, "\" set in \"purgeCookieByName\""));
      resolve();
    }
  });
}

export var getCookie = getCookieByName;
export var purgeCookie = purgeCookieByName;